import { IClientKnowledgeState } from './state';

export const isFetching = (state: { clientKnowledgeState: IClientKnowledgeState }): any => state.clientKnowledgeState.isFetching;
export const getError = (state: { clientKnowledgeState: IClientKnowledgeState }): any => state.clientKnowledgeState.error;
